import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoCadastrosRepasse } from "./subnavs/GestaoCadastros";
import { SubNavGestaoRepasseAtendimentos } from "./subnavs/GestaoRepasseAtendimento";
import { SubNavRelatoriosRepasse } from "./subnavs/RelatoriosRepasse";
import ModalSubNav from "../../../Components/Modais";
import { useState } from "react";
import { IComponentModal } from "../../Modais/IModalComponent";

export default function RepasseTab() {
    const { UserInfor } = useUserInfor();

    const [show, SetShow] = useState(false);
    const [Modal, SetModal] = useState<IComponentModal>();

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="RepasseTab">
            <div
                id="kt_header_menu2"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {/* {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.REPASSE.TELAS.DASHBOARD.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.REPASSE.TELAS
                                                      .DASHBOARD.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Dashboard
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null} */}

                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.REPASSE.TELAS.GESTAO_CLIENTES.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.REPASSE.TELAS
                                                      .GESTAO_CLIENTES.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Gestão de Clientes
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS
                                .MEUS_ATENDIMENTOS.USUARIO.ID_TELA,
                            ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.GRUPO
                                .ID_TELA,
                            ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.TODOS
                                .ID_TELA,
                        ]}
                    >
                        <SubNavGestaoRepasseAtendimentos />
                    </SubNavDropDown>

                    <SubNavDropDown
                        title={"Gestão de Cadastros"}
                        telas={[ACESSOS.REPASSE.TELAS.ETAPAS_GRUPO.ID_TELA]}
                    >
                        <SubNavGestaoCadastrosRepasse
                            SetModal={SetModal}
                            SetShow={SetShow}
                        />
                    </SubNavDropDown>

                    {mostrarNavDeTela(
                        ACESSOS.REPASSE.TELAS.GESTAO_REPASSE.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.REPASSE.TELAS.GESTAO_REPASSE.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Repasse
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[ACESSOS.REPASSE.TELAS.CAPYS_BI.ID_TELA]}
                    >
                        <SubNavRelatoriosRepasse />
                    </SubNavDropDown>
                </ul>
                <ModalSubNav
                    show={show}
                    setShow={SetShow}
                    ModalComponent={Modal}
                />
            </div>
        </div>
    );
}
